import { useState } from "react";
import * as logClient from "@classdojo/log-client";
import { useAfterUnmount } from "@web-monorepo/hooks";

interface TelemetryOptions {
  eventName: string;
  metadata?: Record<string, unknown>;
}

// Logs once, when the component actually unmounts. Callers pass a fresh `metadata` object
// on every render, so this must not hang off a useEffect keyed on `options` -- that re-ran
// the cleanup (and logged a partial duration) on every re-render.
export const useLogRenderedDuration = (options: TelemetryOptions) => {
  const [startTime] = useState(() => Date.now());

  useAfterUnmount(() => {
    const duration = Date.now() - startTime;

    try {
      void logClient.logEvent({
        eventName: options.eventName,
        eventValue: duration,
        metadata: options.metadata,
      });
      // eslint-disable-next-line no-catch-all/no-catch-all -- pre-existing violation
    } catch (error) {
      // eslint-disable-next-line no-console -- pre-existing violation
      console.warn(`Failed to log ${options.eventName} duration:`, error);
    }
  });
};
